/**
 * Launch Promo Hook — first-time-purchase pricing
 *
 * Promo rules:
 * - Single Property Kit: flat $15 price for all buyers. The promo flag is
 *   retained for backwards compatibility but no longer surfaces a discount.
 */
import { useEffect } from 'react';

// Legacy localStorage key from the retired Growth 48h launch promo. Cleared on
// mount so returning visitors don't keep stale state.
const LEGACY_GROWTH_PROMO_KEY = 'lb_growth_promo_started_at';

export interface PromoState {
  /** True if this visitor still qualifies for the first-time Kit price. */
  kitFirstTime: boolean;
}

export function useLaunchPromo(): PromoState {
  useEffect(() => {
    try {
      localStorage.removeItem(LEGACY_GROWTH_PROMO_KEY);
    } catch {}
  }, []);

  // Promo retired — kit is a flat $15 for all buyers.
  return { kitFirstTime: false };
}